import Route from 'cio/routes/base';

export default class BelongsRoute extends Route {
  crumb() {
    return {
      name: 'Belongs To',
      path: this.routeName,
    };
  }

  activate() {
    this.modelFor('person').get('segments').reload();
  }

  model() {
    let person = this.modelFor('person');
    return person.get('segments');
  }
}
